import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import img from '../../../../assets/images/cross-icon.svg.js';
import { createCookie } from '../../utilities/backend-helpers/index.js';
import { swipeElement } from '../../utilities/behavior-helpers/index.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import css_248z from './alert-banner-slide-in.scss.js';

class AlertBannerSlideIn extends s {
    constructor() {
        super();
        this.rtl = false;
        this.closeButtonAltText = 'Сlose';
        this.cookieName = 'alert-banner-slide-in-hidden';
        this._query = '(max-width: 1365px)';
        this._isMobile = false;
    }
    _handleMediaQuery(event) {
        this._isMobile = event.detail.value;
        this.requestUpdate();
    }
    closeBanner(scope = this) {
        var _a;
        (_a = scope.alertBanner) === null || _a === void 0 ? void 0 : _a.classList.remove('shown');
        createCookie(scope.cookieName);
        setTimeout(() => {
            var _a;
            (_a = scope.alertBanner) === null || _a === void 0 ? void 0 : _a.classList.add('hidden');
        }, 1000);
    }
    handleClick() {
        this.closeBanner();
    }
    firstUpdated() {
        this.alertBanner = this.shadowRoot.querySelector('.alert-banner-slide-in');
        const primaryCta = this.alertBanner.querySelector('slot[name="primary-cta"]');
        if (primaryCta)
            primaryCta.addEventListener('click', () => this.handleClick());
    }
    updated() {
        if (this.alertBanner) {
            if (this._isMobile) {
                swipeElement(this.alertBanner, this.closeBanner, this, true);
            }
            setTimeout(() => {
                this.alertBanner.classList.add('shown');
            }, 4000);
        }
    }
    render() {
        return x `<div class="alert-banner-slide-in ${this.rtl || isRTL() ? 'rtl' : ''}"><button class="close" @click="${this.handleClick}" @keyDown="${this.handleClick}" aria-label="${this.closeButtonAltText}"><img src="${img}" alt="${this.closeButtonAltText}"></button><slot name="header"></slot><slot name="text"></slot><div class="cta-container"><slot name="primary-cta"></slot></div></div><lit-media-query .query="${this._query}" @changed="${this._handleMediaQuery}"></lit-media-query>`;
    }
}
AlertBannerSlideIn.styles = css_248z;
__decorate([
    n({ type: Boolean })
], AlertBannerSlideIn.prototype, "rtl", void 0);
__decorate([
    n({ type: String })
], AlertBannerSlideIn.prototype, "closeButtonAltText", void 0);
__decorate([
    n({ type: String })
], AlertBannerSlideIn.prototype, "cookieName", void 0);
__decorate([
    t()
], AlertBannerSlideIn.prototype, "alertBanner", void 0);
customElements.define('alert-banner-slide-in', AlertBannerSlideIn);

export { AlertBannerSlideIn };
